import {
    createFileRoute,
    Outlet,
    useNavigate,
    useRouterState,
} from '@tanstack/react-router';

import { Tabs, TabsList, TabsTrigger } from '@apps/web/components/ui/tabs';

export const Route = createFileRoute('/_app/(main)/training')({
    component: TrainingLayout,
    head: () => ({
        meta: [{ title: 'Staff Training | Phoebe' }],
    }),
});

function TrainingLayout() {
    const navigate = useNavigate();
    const pathname = useRouterState({
        select: (state) => state.location.pathname,
    });

    const activeTab = pathname.endsWith('/onboarding')
        ? 'onboarding'
        : pathname.endsWith('/demo')
          ? 'demo'
          : 'announcement';

    return (
        <div className="flex h-full min-w-0 flex-col overflow-hidden">
            {/* Header */}
            <div className="flex items-center justify-between px-4 py-4 sm:px-6">
                <div className="min-w-0">
                    <h1 className="mb-1 text-xl font-semibold sm:text-2xl">
                        Staff Training
                    </h1>
                    <p className="text-muted-foreground text-sm">
                        Resources to help staff work effectively with Phoebe
                    </p>
                </div>
            </div>
            {/* Content Area */}
            <div className="min-w-0 flex-1 overflow-y-auto px-4 py-4 sm:p-6">
                <div className="mx-auto w-full max-w-5xl min-w-0 space-y-6">
                    <Tabs
                        value={activeTab}
                        onValueChange={(value) => {
                            void navigate({
                                to:
                                    value === 'onboarding'
                                        ? '/training/onboarding'
                                        : value === 'demo'
                                          ? '/training/demo'
                                          : '/training/announcement',
                                replace: true,
                            });
                        }}
                    >
                        <TabsList>
                            <TabsTrigger value="announcement">
                                Announce Phoebe
                            </TabsTrigger>
                            <TabsTrigger value="onboarding">
                                Onboard Caregivers
                            </TabsTrigger>
                            <TabsTrigger value="demo">Demo Page</TabsTrigger>
                        </TabsList>
                    </Tabs>
                    <Outlet />
                </div>
            </div>
        </div>
    );
}
